import {
  provideTablerIcons,
  IconArrowsSort,
  IconSortAscending,
  IconAdjustmentsHorizontal,
  IconAffiliate,
  IconAlertTriangle,
  IconApps,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowsMove,
  IconArrowsRightLeft,
  IconArrowsShuffle,
  IconBell,
  IconBook2,
  IconBrandTeams,
  IconBriefcase,
  IconBriefcaseFilled,
  IconBrowser,
  IconBroadcast,
  IconBuilding,
  IconBulb,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarPlus,
  IconCategory,
  IconChartBar,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronLeftPipe,
  IconChevronRight,
  IconChevronRightPipe,
  IconChevronUp,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleX,
  IconCircleXFilled,
  IconClock,
  IconCopy,
  IconDatabase,
  IconDotsVertical,
  IconDownload,
  IconExternalLink,
  IconEye,
  IconFileDescription,
  IconFileDownload,
  IconFileExport,
  IconFileText,
  IconFileTypeDoc,
  IconFileTypePdf,
  IconFileTypePpt,
  IconFileTypeXls,
  IconFileUpload,
  IconFileWord,
  IconFilter,
  IconFlag,
  IconFolder,
  IconGauge,
  IconHandClick,
  IconHelpCircle,
  IconHome,
  IconHourglass,
  IconInfoCircle,
  IconLanguage,
  IconLayout,
  IconLayoutGrid,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconLibrary,
  IconList,
  IconLoader2,
  IconLoader4,
  IconMail,
  IconMap,
  IconMapPin,
  IconMaximize,
  IconMessageCheck,
  IconMessageCircle2,
  IconMessageReport,
  IconMessages,
  IconMinus,
  IconPackage,
  IconPaperclip,
  IconEdit,
  IconPencil,
  IconPencilPlus,
  IconPhone,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconPlayerSkipBackFilled,
  IconPlayerSkipForwardFilled,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconPlus,
  IconPoint,
  IconRefresh,
  IconReport,
  IconRobot,
  IconRotateClockwise2,
  IconSearch,
  IconSortDescending,
  IconSparkles,
  IconSquareFilled,
  IconStack2,
  IconStar,
  IconStarFilled,
  IconTag,
  IconTarget,
  IconTerminal2,
  IconThumbDown,
  IconThumbUp,
  IconTrendingDown,
  IconTrendingUp,
  IconTriangleFilled,
  IconUser,
  IconUserCog,
  IconUsers,
  IconUsersGroup,
  IconVideo,
  IconShare,
  IconWand,
  IconWorld,
  IconX,
  IconShare2,
  IconArrowForward,
  IconTable,
  IconCircleMinus,
  IconDevices,
  IconLogout,
  IconBolt,
  IconMenu2,
  IconUserHexagon,
  IconDeviceDesktop,
  IconClipboardList,
  IconTargetArrow,
} from '@tabler/icons-angular';

export const tablerIconsProvider = provideTablerIcons({
  IconArrowsSort,
  IconSortAscending,
  IconAdjustmentsHorizontal,
  IconAffiliate,
  IconAlertTriangle,
  IconApps,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowsMove,
  IconArrowsRightLeft,
  IconArrowsShuffle,
  IconBell,
  IconBook2,
  IconBrandTeams,
  IconBriefcase,
  IconBriefcaseFilled,
  IconBrowser,
  IconBroadcast,
  IconBuilding,
  IconBulb,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarPlus,
  IconCategory,
  IconChartBar,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronLeftPipe,
  IconChevronRight,
  IconChevronRightPipe,
  IconChevronUp,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleX,
  IconCircleXFilled,
  IconClock,
  IconCopy,
  IconDatabase,
  IconDotsVertical,
  IconDownload,
  IconExternalLink,
  IconEye,
  IconFileDescription,
  IconFileDownload,
  IconFileExport,
  IconFileText,
  IconFileTypeDoc,
  IconFileTypePdf,
  IconFileTypePpt,
  IconFileTypeXls,
  IconFileUpload,
  IconFileWord,
  IconFilter,
  IconFlag,
  IconFolder,
  IconGauge,
  IconHandClick,
  IconHelpCircle,
  IconHome,
  IconHourglass,
  IconInfoCircle,
  IconLanguage,
  IconLayout,
  IconLayoutGrid,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconLibrary,
  IconList,
  IconLoader2,
  IconLoader4,
  IconMail,
  IconMap,
  IconMapPin,
  IconMaximize,
  IconMessageCheck,
  IconMessageCircle2,
  IconMessageReport,
  IconMessages,
  IconMinus,
  IconPackage,
  IconPaperclip,
  IconEdit,
  IconPencil,
  IconPencilPlus,
  IconPhone,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconPlayerSkipBackFilled,
  IconPlayerSkipForwardFilled,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconPlus,
  IconPoint,
  IconRefresh,
  IconReport,
  IconRobot,
  IconRotateClockwise2,
  IconSearch,
  IconSortDescending,
  IconSparkles,
  IconSquareFilled,
  IconStack2,
  IconStar,
  IconStarFilled,
  IconTag,
  IconTarget,
  IconTerminal2,
  IconThumbDown,
  IconThumbUp,
  IconTrendingDown,
  IconTrendingUp,
  IconTriangleFilled,
  IconUser,
  IconUserCog,
  IconUsers,
  IconUsersGroup,
  IconVideo,
  IconShare,
  IconWand,
  IconWorld,
  IconX,
  IconShare2,
  IconArrowForward,
  IconTable,
  IconCircleMinus,
  IconDevices,
  IconLogout,
  IconBolt,
  IconMenu2,
  IconUserHexagon,
  IconDeviceDesktop,
  IconClipboardList,
  IconTargetArrow,
});
